import script from "./SectionMallBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionMallBanner.vue?vue&type=script&setup=true&lang=ts"

import "./SectionMallBanner.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__